module.exports = new __parcel__URL__("task-one-illustration-dark.8a85ce87.png").toString();